import { useScreenSize } from '@/hooks';
import { type SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};
export const MoveToBuildingIcon = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M14 12.5H21.2058C23.1782 12.5 24.7772 14.099 24.7772 16.0714C24.7772 18.0439 23.1782 19.6429 21.2058 19.6429H18.5348C16.3651 19.6429 14.6062 21.4017 14.6062 23.5714C14.6062 25.7411 16.3651 27.5 18.5348 27.5H27"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path d="M25 24.5C26.1716 25.6716 26.8284 26.3284 28 27.5L25 30" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="13.5" cy="12.5" r="1.75" fill={fill} stroke={fill} strokeWidth="1.5" />
        </svg>
    );
};
